import profileApi from 'api/profile'

import {
  ProfileListResponse,
  ProfileSaveRequest,
  userDetailsResponse
} from './types'

const ProfileApiSlice = profileApi.injectEndpoints({
  endpoints: (build) => ({
    createProfile: build.mutation<ProfileListResponse, ProfileSaveRequest>({
      query: (profileData) => {
        return {
          url: '/company/extended',
          method: 'POST',
          data: profileData,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['profile']
    }),
    updateProfile: build.mutation<ProfileListResponse, ProfileSaveRequest>({
      query: (profileData) => {
        return {
          url: `/company/extended/${profileData.id}`,
          method: 'PATCH',
          data: profileData,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['profile']
    }),
    updateDocument: build.mutation<ProfileListResponse, ProfileSaveRequest>({
      query: (profileData) => {
        const { id: companyId, documentDTOS } = profileData as any
        return {
          url: `/documents/${companyId}`,
          method: 'PATCH',
          data: documentDTOS,
          headers: { 'Content-Type': 'application/json' }
        }
      },
      invalidatesTags: ['profile']
    }),
    getProfile: build.query<ProfileListResponse, { id: string | undefined }>({
      query: ({ id }) => ({
        url: `/profile/${id}`,
        method: 'GET'
      }),
      providesTags: ['profile']
    }),
    getUserDetails: build.query<userDetailsResponse, void>({
      query: () => ({
        url: '/user/extended',
        method: 'GET'
      }),
      providesTags: ['userDetails']
    }),
    SaveUserDetails: build.mutation<
      userDetailsResponse,
      { payload: any, token: string }
    >({
      query: ({ payload, token }) => ({
        url: '/sync-user',
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }),
      invalidatesTags: ['userDetails']
    }),
    UpdateSyncUserDetails: build.mutation<
      userDetailsResponse,
      { firebaseId: string, updatePayload: any, token: string }
    >({
      query: ({ firebaseId, updatePayload, token }) => ({
        url: `/update-user/${firebaseId}`,
        method: 'PATCH',
        data: updatePayload,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }),
      invalidatesTags: ['userDetails']
    })
  })
})

export const {
  useCreateProfileMutation,
  useUpdateProfileMutation,
  useGetProfileQuery,
  useGetUserDetailsQuery,
  useSaveUserDetailsMutation,
  useUpdateSyncUserDetailsMutation,
  useUpdateDocumentMutation
} = ProfileApiSlice
